import { ObstetricsConstants } from './obstetrics.constants'
import { IObstetricsAction, IObstetricsState } from './obstetrics.types'

export const initialObstetricsState: IObstetricsState = {
  isPatientPregnant: null,
  isPatientPregnantPNNV: null,
  gravida: '',
  para: '',
  gestationAgeWeeks: null,
  gestationAgeDays: null,
  expectedDateOfConfinement: '',
  lastMenstrualPeriod: '',
  initialFetalHeartRate: '',
  contractionsFreq: '',
  contractionsDur: '',
  membranes: [],
  ruptureTime: '',
  dilation: '',
  effacement: null,
  maternalMedicationsAdministered: [],
  presentingPart: '',
  bloodyShow: null,
  prenatalCare: null,
  comments: '',
}

export function obstetricsReducer(
  state: IObstetricsState = initialObstetricsState,
  action: IObstetricsAction
): IObstetricsState {
  switch (action.type) {
    case ObstetricsConstants.SET_IS_PATIENT_PREGNANT:
      return { ...state, isPatientPregnant: action.isPatientPregnant }
    case ObstetricsConstants.SET_IS_PATIENT_PREGNANT_PNNV:
      return { ...state, isPatientPregnantPNNV: action.isPatientPregnantPNNV }
    case ObstetricsConstants.SET_GRAVIDA:
      return { ...state, gravida: action.gravida }
    case ObstetricsConstants.SET_PARA:
      return { ...state, para: action.para }
    case ObstetricsConstants.SET_GESTATIONAL_AGE_WEEKS:
      return { ...state, gestationAgeWeeks: action.gestationAgeWeeks }
    case ObstetricsConstants.SET_GESTATIONAL_AGE_DAYS:
      return { ...state, gestationAgeDays: action.gestationAgeDays }
    case ObstetricsConstants.SET_EXPECTED_DATE_OF_CONFINEMENT:
      return { ...state, expectedDateOfConfinement: action.expectedDateOfConfinement }
    case ObstetricsConstants.SET_LAST_MENSTRUAL_PERIOD:
      return { ...state, lastMenstrualPeriod: action.lastMenstrualPeriod }
    case ObstetricsConstants.SET_INITIAL_FETAL_HEART_RATE:
      return { ...state, initialFetalHeartRate: action.initialFetalHeartRate }
    case ObstetricsConstants.SET_CONTRACTIONS_FREQUENCY:
      return { ...state, contractionsFreq: action.contractionsFreq }
    case ObstetricsConstants.SET_CONTRACTIONS_DURATION:
      return { ...state, contractionsDur: action.contractionsDur }
    case ObstetricsConstants.SET_MEMBRANES_AMNIOTIC_FLUID:
      return { ...state, membranes: action.membranes }
    case ObstetricsConstants.SET_RUPTURE_TIME:
      return { ...state, ruptureTime: action.ruptureTime }
    case ObstetricsConstants.SET_DILATION:
      return { ...state, dilation: action.dilation }
    case ObstetricsConstants.SET_EFFACEMENT:
      return { ...state, effacement: action.effacement }
    case ObstetricsConstants.SET_MATERNAL_MEDICATIONS_ADMINISTERED:
      return { ...state, maternalMedicationsAdministered: action.maternalMedicationsAdministered }
    case ObstetricsConstants.SET_PRESENTING_PART:
      return { ...state, presentingPart: action.presentingPart }
    case ObstetricsConstants.SET_BLOODY_SHOW:
      return { ...state, bloodyShow: action.bloodyShow }
    case ObstetricsConstants.SET_PRENATAL_CARE:
      return { ...state, prenatalCare: action.prenatalCare }
    case ObstetricsConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case ObstetricsConstants.RESET_OBSTETRICS:
      return { ...initialObstetricsState }
    case ObstetricsConstants.SET_OBSTETRICS:
      return { ...action.obstetrics }
    default:
      return state
  }
}
